import React from 'react'
import EmblaCarousel from './embla/emblaCarousel'
import { GatsbyImage } from 'gatsby-plugin-image'
import { PrismicRichText } from '@prismicio/react'

const Logo = ({ partner }) => {
  return (
    <div className='flex max-h-9 justify-center items-center h-full px-4 lg:px-12'>
      <GatsbyImage height={36} width={100} imgClassName='h-9' image={partner.logo.gatsbyImageData} alt={partner.logo.alt || ''} loading='eager' />
    </div>
  )
}

const Partners = ({ slice }) => {
  return (
    <div className='bg-white dark:bg-brandBlue'>
      <div className={`component-${slice.slice_type} relative mx-auto py-8 lg:py-16`}>
        {slice.primary.title && (
          <div className='prose prose-lg max-w-none text-center dark:prose-invert'>
            <PrismicRichText field={slice.primary.title.richText} />
          </div>
        )}
        <div className='mt-10 flex flex-row flex-wrap items-center justify-center sm:flex-nowrap'>
          <EmblaCarousel options={{ align: 'start', autoplay: true, dots: true, loop: true, skipSnaps: false, slidesToScroll: 1 }}>
            {slice.items.map((partner, index) => {
              return (
                <div className='embla__slide relative dark:bg-slate-100 dark:bg-opacity-40 dark:p-4' key={`partner-${index}`}>
                  {partner.link?.url ? (
                    <a href={partner.link.url} rel='noopener noreferrer nofollow' target='_blank'>
                      <Logo partner={partner} />
                    </a>
                  ) : (
                    <Logo partner={partner} />
                  )}
                </div>
              )
            })}
          </EmblaCarousel>
        </div>
      </div>
    </div>
  )
}

export default Partners
